import { render } from "./ReportError.vue?vue&type=template&id=f0caf4e4"
import script from "./ReportError.vue?vue&type=script&lang=js"
export * from "./ReportError.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__